import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhonelinkLockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phonelink_lock"}/>
}
